import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "Menu"
}
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_BarChartCard = _resolveComponent("BarChartCard")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_CashFlowPlan = _resolveComponent("CashFlowPlan")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_AccountingTable = _resolveComponent("AccountingTable")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_ctx.budget && _ctx.isAuthorized)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_tabs, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
          style: {"background":"#f4f4f4","border-radius":"16px","overflow":"hidden"}
        }, {
          default: _withCtx(() => [
            (_ctx.budget && _ctx.budget.accountingLines)
              ? (_openBlock(), _createBlock(_component_v_tab, {
                  key: 0,
                  value: "Charts",
                  href: "#Charts"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Graphiques")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.budget && _ctx.budget.accountingLines)
              ? (_openBlock(), _createBlock(_component_v_tab, {
                  key: 1,
                  value: "CashFlowPlan",
                  href: "#CashFlowPlan"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Plan de trésorerie")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.budget && _ctx.budget.accountingLines)
              ? (_openBlock(), _createBlock(_component_v_tab, {
                  key: 2,
                  value: "Forecast",
                  href: "#Forecast"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Atterrissage")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isAccountingUser && _ctx.budget && _ctx.budget.accountingLines)
              ? (_openBlock(), _createBlock(_component_v_tab, {
                  key: 3,
                  value: "AccountableAccount",
                  href: "#AccountableAccount"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Comptes Comptables")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_tab, {
              value: "fixedAssets",
              href: "#fixedAssets"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Investissements et financements")
              ])),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: "socialCharge",
              href: "#socialCharge"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Salaires")
              ])),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: "amortisation",
              href: "#amortisation"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Amortissements")
              ])),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: "incomeStatement",
              href: "#incomeStatement"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Compte de résultat")
              ])),
              _: 1
            }),
            _createVNode(_component_v_tab, {
              value: "wcr",
              href: "#wcr"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("BFR")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_tabs_window, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTab) = $event))
        }, {
          default: _withCtx(() => [
            (_ctx.datasets)
              ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                  key: 0,
                  value: "Charts"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_BarChartCard, {
                              ref: "cashFlowChart",
                              title: _ctx.$t('shared.cashFlow'),
                              legend: true,
                              loading: _ctx.cashFlowBudgetLoading,
                              data: _ctx.cashFlowBudgetData,
                              activeBack: false,
                              selectedPeriod: _ctx.selectedPeriod,
                              yearNMinus1: false
                            }, null, 8, ["title", "loading", "data", "selectedPeriod"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_BarChartCard, {
                              ref: "profitAndLossForecastVersusActual",
                              title: _ctx.$t('shared.profitAndLossForecastVersusActual'),
                              legend: true,
                              loading: _ctx.forecastBudgetWithActualLoading,
                              data: _ctx.profitAndLossForecastVersusActualData,
                              activeBack: false,
                              selectedPeriod: _ctx.selectedPeriod,
                              yearNMinus1: false
                            }, null, 8, ["title", "loading", "data", "selectedPeriod"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_BarChartCard, {
                              ref: "salesForecastVersusActual",
                              title: _ctx.$t('shared.salesForecastVersusActual'),
                              legend: true,
                              loading: _ctx.forecastBudgetWithActualLoading,
                              data: _ctx.salesForecastVersusActualData,
                              activeBack: false,
                              selectedPeriod: _ctx.selectedPeriod,
                              yearNMinus1: false
                            }, null, 8, ["title", "loading", "data", "selectedPeriod"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_BarChartCard, {
                              ref: "purchaseForecastVersusActual",
                              title: _ctx.$t('shared.purchaseForecastVersusActual'),
                              legend: true,
                              loading: _ctx.forecastBudgetWithActualLoading,
                              data: _ctx.purchaseForecastVersusActualData,
                              activeBack: false,
                              selectedPeriod: _ctx.selectedPeriod,
                              yearNMinus1: false
                            }, null, 8, ["title", "loading", "data", "selectedPeriod"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.datasets)
              ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                  key: 1,
                  value: "CashFlowPlan"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_CashFlowPlan, {
                        companyId: _ctx.companyId,
                        inBudgetId: _ctx.budgetId,
                        selectedPeriod: _ctx.selectedPeriod,
                        refreshData: _ctx.refreshData
                      }, null, 8, ["companyId", "inBudgetId", "selectedPeriod", "refreshData"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.datasets)
              ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                  key: 2,
                  value: "Forecast"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-4 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              outlined: "",
                              modelValue: _ctx.forecastMonth,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.forecastMonth) = $event)),
                              items: _ctx.forecastMonths,
                              label: "Période",
                              "item-value": "value",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.name
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            (_ctx.forecastBudgetWithActualLoading)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  size: 70,
                                  width: 7,
                                  color: "primary",
                                  indeterminate: "",
                                  style: {"margin":"24px"}
                                }))
                              : (_ctx.forecastDetails && _ctx.forecastDetails.length)
                                ? (_openBlock(), _createBlock(_component_v_data_table, {
                                    key: 1,
                                    headers: _ctx.forecastHeaders,
                                    items: _ctx.forecastDetails,
                                    "items-per-page": _ctx.forecastDetails.length,
                                    "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.forecastDetails.length) = $event)),
                                    class: "table",
                                    "hide-default-footer": ""
                                  }, {
                                    item: _withCtx((props) => [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", {
                                          class: "text-left",
                                          style: _normalizeStyle(props.item.strong ? 'font-weight: bold' : '')
                                        }, _toDisplayString(props.item.type), 5),
                                        _createElementVNode("td", {
                                          class: "text-right",
                                          style: _normalizeStyle(props.item.strong ? 'font-weight: bold' : '')
                                        }, _toDisplayString(_ctx.formatAmount(props.item.value, 0)), 5)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items", "items-per-page"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.budget && _ctx.budget.accountingLines)
              ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                  key: 3,
                  value: "AccountableAccount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: _ctx.headers,
                      items: _ctx.accountableAccountItems,
                      "items-per-page-options": [5, 10, 25],
                      class: "table mt-2",
                      "fixed-header": "",
                      height: "60vh",
                      density: "compact"
                    }, {
                      item: _withCtx((props) => [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item, (item, i) => {
                            return (_openBlock(), _createElementBlock("td", { key: i }, [
                              (i === 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(item), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(item, { currency: "" })), 1))
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_tabs_window_item, {
              value: "fixedAssets",
              class: "pt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountingTable, {
                  ref: "fixedAssets",
                  options: _ctx.fixedAssetsOptions,
                  budgetId: _ctx.budgetId,
                  periods: []
                }, null, 8, ["options", "budgetId"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs_window_item, {
              value: "amortisation",
              class: "pt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountingTable, {
                  ref: "amortisation",
                  options: _ctx.amortisationOptions,
                  budgetId: _ctx.budgetId,
                  periods: []
                }, null, 8, ["options", "budgetId"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs_window_item, {
              value: "socialCharge",
              class: "pt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountingTable, {
                  ref: "socialCharge",
                  options: _ctx.socialChargeOptions,
                  budgetId: _ctx.budgetId,
                  periods: []
                }, null, 8, ["options", "budgetId"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs_window_item, {
              value: "incomeStatement",
              class: "pt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountingTable, {
                  ref: "incomeStatement",
                  options: _ctx.incomeStatementOptions,
                  budgetId: _ctx.budgetId,
                  periods: []
                }, null, 8, ["options", "budgetId"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs_window_item, {
              value: "wcr",
              class: "pt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountingTable, {
                  ref: "bfr",
                  options: _ctx.bfrOptions,
                  budgetId: _ctx.budgetId,
                  periods: []
                }, null, 8, ["options", "budgetId"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}